import $ from 'jquery';
import listService from 'ListService';

import { View } from 'backbone';

import formatTemplate from 'properties/main/page.ejs';


class MainPageView extends View {


    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=radio]' : 'setPageValue',
            'change #selectSpecificPage' : 'setSpecificPage'
        };

        if (!this.model.get('pageType')) {
            this.model.set('pageType', 'next', {silent:true});
        }
        if (!this.model.get('pageItems')) {
            this.model.set('pageItems', ['Page 1','Page 2','Page 3'], {silent:true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

     setPageValue(evt){
        evt.preventDefault();
        let propVal  = evt.currentTarget.value;
        switch(propVal){
            case 'next':
            case 'previous':
            case 'back':
                propVal = evt.currentTarget.value;
                this.model.set('pageType', propVal);
                break;
            case 'specific':
                const pageVal =$('#selectSpecificPage').val();
                this.model.set('pageValue', pageVal, {silent:true});
                this.model.set('page', listService.getCleanedId(pageVal), {silent:true});
                this.model.set('pageType', propVal);
                break;
            default:this.model.set('pageType', propVal);break;
        }
    }

    setSpecificPage(evt){
        evt.preventDefault();
        const propVal  = evt.currentTarget.value;
        this.model.set('page', listService.getCleanedId( propVal ));
    }

    activateSpecificOption(){
        $('#selectSpecificPage').attr('disabled', false);
        $(`:radio[value='specific']`).attr('checked', true);
        $('option[value="' + listService.cleanId( this.model.get('page') ) + '"]').attr('selected', true);
    }

    activateCommonOption(){
        $(`:radio[value='${this.model.get('pageType')}']`).attr('checked', true);
    }

    addPages(){
        let pagesList = [];
        $('#selectSpecificPage').empty();

        listService.pageList.map( v => {
            $('#selectSpecificPage').append('<option value="' + v.model.get('id') + '">' + v.model.get('name') + '</option>')

        });


    }

    render() {
        // Current Rendering of the backbone view.
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.addPages();

        // Hiding and selecting elements according to the Page option that was selected.
        let currentPageValue=this.model.get('pageType');


        if (currentPageValue === 'specific') {
            this.activateSpecificOption();
        } else {
            this.activateCommonOption()
        }


        this.delegateEvents();
        return this;
    }


}

export default MainPageView;
